import { IMIMEType } from "../Interfaces/IMIMEType";

export const staticMimeType: IMIMEType[] = [
  { idMIMEType: 1, MIMEType: "application/pdf", FileExtension: "pdf" },
  { idMIMEType: 2, MIMEType: "image/jpeg", FileExtension: "jpg" },
  { idMIMEType: 3, MIMEType: "image/jpeg", FileExtension: "jpeg" },
  { idMIMEType: 4, MIMEType: "image/jpeg", FileExtension: "jpe" },
  { idMIMEType: 5, MIMEType: "image/png", FileExtension: "png" },
];
